/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  InspectionResultResponse,
  PagedResultsResponse,
  SubmitFormRequest,
} from '../models/index';
import {
    InspectionResultResponseFromJSON,
    InspectionResultResponseToJSON,
    PagedResultsResponseFromJSON,
    PagedResultsResponseToJSON,
    SubmitFormRequestFromJSON,
    SubmitFormRequestToJSON,
} from '../models/index';

export interface GetResultByIdRequest {
    id: string;
}

export interface QueryResultsRequest {
    machineId?: string;
    machinePartId?: string;
    categoryId?: string;
    dateFrom?: string;
    dateTo?: string;
    pageNumber?: number;
    perPage?: number;
}

export interface SubmitFormOperationRequest {
    id: string;
    submitFormRequest: SubmitFormRequest;
}

/**
 * 
 */
export class InspectionResultsApi extends runtime.BaseAPI {

    /**
     * Retrieves a single inspection result by its ID, including all section answers.
     * Get a single inspection result
     */
    async getResultByIdRaw(requestParameters: GetResultByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionResultResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getResultById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/results/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionResultResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a single inspection result by its ID, including all section answers.
     * Get a single inspection result
     */
    async getResultById(requestParameters: GetResultByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionResultResponse> {
        const response = await this.getResultByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves inspection results with optional filtering by machineId, machinePartId, categoryId, and date range. Supports pagination via pageNumber and perPage parameters.
     * Query inspection results
     */
    async queryResultsRaw(requestParameters: QueryResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedResultsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['machineId'] != null) {
            queryParameters['machineId'] = requestParameters['machineId'];
        }

        if (requestParameters['machinePartId'] != null) {
            queryParameters['machinePartId'] = requestParameters['machinePartId'];
        }

        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = requestParameters['dateFrom'];
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = requestParameters['dateTo'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/results`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedResultsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves inspection results with optional filtering by machineId, machinePartId, categoryId, and date range. Supports pagination via pageNumber and perPage parameters.
     * Query inspection results
     */
    async queryResults(requestParameters: QueryResultsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedResultsResponse> {
        const response = await this.queryResultsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submits a completed inspection form. Validates that all required sections (NUMBER_ENTRY and STATUS_CHECK) have answers with type-consistent values. Creates an InspectionResult, generates HealthReading records for trending, and transitions the form status to COMPLETED. Submitted results are append-only and cannot be modified after submission.
     * Submit completed form answers
     */
    async submitFormRaw(requestParameters: SubmitFormOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionResultResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling submitForm().'
            );
        }

        if (requestParameters['submitFormRequest'] == null) {
            throw new runtime.RequiredError(
                'submitFormRequest',
                'Required parameter "submitFormRequest" was null or undefined when calling submitForm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/forms/{id}/submit`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitFormRequestToJSON(requestParameters['submitFormRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionResultResponseFromJSON(jsonValue));
    }

    /**
     * Submits a completed inspection form. Validates that all required sections (NUMBER_ENTRY and STATUS_CHECK) have answers with type-consistent values. Creates an InspectionResult, generates HealthReading records for trending, and transitions the form status to COMPLETED. Submitted results are append-only and cannot be modified after submission.
     * Submit completed form answers
     */
    async submitForm(requestParameters: SubmitFormOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionResultResponse> {
        const response = await this.submitFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
